export async function FetchWithAuth(url, options = {}) {
  const token = localStorage.getItem("token");

  let headers = {
    ...(options.headers || {}),
    "Authorization": token ? `Bearer ${token}` : "",
  };

  // Kalau body berupa FormData, hapus Content-Type agar browser yang set boundary
  if (options.body instanceof FormData) {
    delete headers["Content-Type"];
  } else {
    headers["Content-Type"] = "application/json";
  }

  const res = await fetch(url, {
    ...options,
    headers,
  });

  // Debugging response
  //console.log(await res.text()); // ⚠️ jangan dipanggil 2x, response body bisa habis

  if (res.status === 401) {
    localStorage.removeItem("token");
    window.location.href = "/admin/login";
    return;
  }

  return res;
}
